import { Box, EllipsisText, Flex, Image } from '@shared/components';

interface ExamCenterItemProps {
  logoSrc?: string | null;
  name?: string;
  minify?: boolean;
}

export default function ExamCenterItem(props: Readonly<ExamCenterItemProps>) {
  const { logoSrc, name, minify: shouldMinify } = props;

  return (
    <Flex sx={{ alignItems: 'center', gap: (theme) => theme.spacing(3) }}>
      {logoSrc ? (
        <Image
          src={logoSrc}
          sx={{
            width: '24px',
            aspectRatio: 1,
            borderRadius: (theme) => theme.shape.rounded(1),
            flexShrink: 0,
          }}
        />
      ) : (
        <Box
          sx={(theme) => ({
            width: '24px',
            aspectRatio: 1,
            backgroundColor: theme.palette.grey[200],
            borderRadius: theme.shape.rounded(1),
            flexShrink: 0,
          })}
        />
      )}
      {!shouldMinify ? (
        <EllipsisText variant='body2' sx={{ textAlign: 'start', wordBreak: 'break-all' }}>
          {name ?? 'ไม่มี'}
        </EllipsisText>
      ) : null}
    </Flex>
  );
}
